import { render, staticRenderFns } from "./accident-injureds.vue?vue&type=template&id=e6594a60"
import script from "./accident-injureds.vue?vue&type=script&lang=js"
export * from "./accident-injureds.vue?vue&type=script&lang=js"
import style0 from "./accident-injureds.vue?vue&type=style&index=0&id=e6594a60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports